<div class="modal-overlay" *ngIf="isOpen">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button class="close-button" (click)="closeModal()">&times;</button>

    <!-- Login Form -->
    <div *ngIf="activeForm === 'login'" class="form-container">
      <h2>Login</h2>

      <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">
        <div class="form-group">
          <label>Enter School ID</label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">school</mat-icon>
            <input type="text" formControlName="schoolId" (blur)="validateSchoolId($event, loginForm)"
              placeholder="Enter School ID" />
            <div class="validation-icon">
              <mat-icon *ngIf="
                  loginForm.controls['schoolId'].touched && !isValidSchoolId
                " class="invalid-icon">close</mat-icon>
              <mat-icon *ngIf="
                  loginForm.controls['schoolId'].touched && isValidSchoolId
                " class="valid-icon">check</mat-icon>
            </div>
          </div>
          <div *ngIf="loginSubmitted && loginForm.controls['schoolId'].invalid" class="error-message">
            School ID is required
          </div>
        </div>

        <div class="form-group">
          <label>Phone Number or Email</label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">call</mat-icon>
            <input type="text" formControlName="phoneNumber" placeholder="Phone Number or Email" />
          </div>
          <div *ngIf="loginSubmitted && loginForm.controls['phoneNumber'].invalid" class="error-message">
            Phone number or email is required
          </div>
        </div>

        <div class="form-group">
          <label>Password</label>
          <div class="input-with-icon">
            <mat-icon class="input-icon clickable" (click)="showloginpass()"
              [fontIcon]="showPassword ? 'visibility_off' : 'visibility'">
            </mat-icon>

            <input [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="Password" />
          </div>
          <div *ngIf="loginSubmitted && loginForm.controls['password'].invalid" class="error-message">
            Password is required
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="primary-btn" [disabled]="isLoading">
            {{ isLoading ? "Logging in..." : "Login" }}
          </button>
        </div>
      </form>

      <div class="form-footer">
        <a href="#" (click)="switchToSignup($event)">New User? Create an Account</a>
        <!-- <a href="#" (click)="switchToForgot($event)">Forgot Password?</a> -->
        <div *ngIf="activeForm==='login'">
          <div #googleBtn></div>
        </div>
        <a href="#" (click)="openPrivacyPolicy()">View Privacy Policy</a>


      </div>
    </div>

    <!-- Signup Form -->
    <div *ngIf="activeForm === 'signup'" class="form-container">
      <h2>SignUp</h2>

      <div class="stepper-labels">
        <span class="step-label" *ngIf="currentStep === 1">School Details</span>
        <span class="step-label" *ngIf="currentStep === 2">Personal Details</span>
        <div class="progress-bar">
          <div class="progress-fill" [style.width]="currentStep === 2 ? '100%' : '50%'"></div>
        </div>
      </div>

      <div *ngIf="currentStep === 1">
        <form [formGroup]="signupStep1Form">
          <div class="form-group">
            <label>School ID</label>
            <div class="input-with-icon">
              <mat-icon class="input-icon">school</mat-icon>
              <input type="text" formControlName="schoolId" (blur)="validateSchoolId($event, signupStep1Form)"
                placeholder="School ID" />
              <div class="validation-icon">
                <mat-icon *ngIf="
                    signupStep1Form.controls['schoolId'].touched &&
                    !isValidSchoolId
                  " class="invalid-icon">close</mat-icon>
                <mat-icon *ngIf="
                    signupStep1Form.controls['schoolId'].touched &&
                    isValidSchoolId
                  " class="valid-icon">check</mat-icon>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Select Class</label>
            <div class="input-with-icon">
              <mat-icon class="input-icon">class</mat-icon>
              <select formControlName="classOrder" (change)="onClassChange($event)">
                <option value="" disabled selected hidden>Select Class</option>
                <option *ngFor="let class of classes" [value]="class.classOrder">
                  {{ formatFullName(class.classname) }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label>Select Section</label>
            <div class="input-with-icon">
              <mat-icon class="input-icon">group</mat-icon>
              <select formControlName="sectionId">
                <option value="" disabled selected hidden>
                  Select Section
                </option>
                <option *ngFor="let section of filteredSections" [value]="section.sectionId">
                  {{ formatFullName(section.classname) }}({{
                  formatFullName(section.sectionname)
                  }})
                </option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label>Select Type</label>
            <div class="input-with-icon">
              <mat-icon class="input-icon">person</mat-icon>
              <select formControlName="userType">
                <option value="PRINCIPAL">PRINCIPAL</option>
                <option value="TEACHER">TEACHER</option>
              </select>
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="primary-btn" (click)="onSignupStep1Submit()"
              [disabled]="signupStep1Form.invalid || isLoading">
              {{ isLoading ? "Verifying..." : "Continue" }}
            </button>
          </div>
        </form>
      </div>

      <div *ngIf="currentStep === 2">
        <form [formGroup]="signupStep2Form">
          <div class="form-group">
            <label>First Name</label>
            <div class="input-with-icon">
              <mat-icon class="input-icon">person</mat-icon>
              <input type="text" formControlName="firstName" placeholder="First Name" />
            </div>
          </div>

          <div class="form-group">
            <label>Last Name</label>
            <div class="input-with-icon">
              <mat-icon class="input-icon">person</mat-icon>
              <input type="text" formControlName="lastName" placeholder="Last Name" />
            </div>
          </div>

          <div class="form-group">
            <label>Gender</label>
            <div class="input-with-icon">
              <mat-icon class="input-icon">wc</mat-icon>
              <select formControlName="gender">
                <option value="M">Male</option>
                <option value="F">Female</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label>Phone Number</label>
            <div class="input-with-icon">
              <mat-icon class="input-icon">call</mat-icon>
              <input type="text" formControlName="phoneNumber" placeholder="Phone Number" />
            </div>
          </div>

          <div class="form-group">
            <label>Password</label>
            <div class="input-with-icon">
              <mat-icon class="input-icon clickable" (click)="showloginpass()"
                [fontIcon]="showPassword ? 'visibility_off' : 'visibility'">
              </mat-icon>

              <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
                placeholder="Enter Password" />
            </div>
          </div>

          <div class="form-group">
            <label>Email (optional)</label>
            <div class="input-with-icon">
              <mat-icon class="input-icon">mail</mat-icon>
              <input type="email" formControlName="email" placeholder="Email (optional)" />
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="secondary-btn" (click)="currentStep = 1">
              ← Back
            </button>
            <button type="button" class="primary-btn" (click)="onSignupSubmit()" [disabled]="
                signupStep1Form.invalid || signupStep2Form.invalid || isLoading
              ">
              {{ isLoading ? "Signing up..." : "Submit" }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Forgot Password Form -->
    <div *ngIf="activeForm === 'forgot'" class="form-container">
      <h2>Forgot Password</h2>

      <form [formGroup]="forgotForm" (ngSubmit)="onForgotSubmit()">
        <div class="form-group">
          <label>Enter School ID</label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">school</mat-icon>
            <input type="text" formControlName="schoolId" placeholder="Enter School ID" />
          </div>
        </div>

        <div class="form-group">
          <label>Phone Number or Email</label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">call</mat-icon>
            <input type="text" formControlName="phoneNumber" placeholder="Phone Number or Email" />
          </div>
        </div>

        <div class="form-group">
          <label>New Password</label>
          <div class="input-with-icon">
            <mat-icon class="input-icon clickable" (click)="showloginpass()"
              [fontIcon]="showPassword ? 'visibility_off' : 'visibility'">
            </mat-icon>
            <input [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="New Password" />
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="primary-btn" [disabled]="isLoading">
            {{ isLoading ? "Resetting..." : "Reset Password" }}
          </button>
        </div>
      </form>
    </div>

    <!-- Enquiry Form -->
    <div *ngIf="activeForm === 'enquiry'" class="form-container">
      <h2>Enquire Now</h2>

      <form [formGroup]="enquiryForm" (ngSubmit)="onEnquirySubmit()">

        <!-- Full Name -->
        <div class="form-group">
          <label>Full Name <span style="color: red;">*</span></label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">person</mat-icon>
            <input type="text" formControlName="fullName" placeholder="Your full name" />
          </div>
          <div *ngIf="enquirySubmitted && enquiryForm.controls['fullName'].invalid" class="error-message">
            Full Name is required
          </div>
        </div>

        <!-- School Name -->
        <div class="form-group">
          <label>School Name <span style="color: red;">*</span></label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">school</mat-icon>
            <input type="text" formControlName="schoolName" placeholder="Your school name" />
          </div>
          <div *ngIf="enquirySubmitted && enquiryForm.controls['schoolName'].invalid" class="error-message">
            School Name is required
          </div>
        </div>

        <!-- No. of Children -->
        <div class="form-group">
          <label>No. of Children in your School <span style="color: red;">*</span></label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">groups</mat-icon>
            <select formControlName="noOfChildren">
              <option value="" disabled>Select range</option>
              <option value="30">1–30</option>
              <option value="100">31–100</option>
              <option value="300">101–300</option>
              <option value="1000">400-1000</option>
            </select>
          </div>
          <div *ngIf="enquirySubmitted && enquiryForm.controls['noOfChildren'].invalid" class="error-message">
            Please select number of children
          </div>
        </div>

        <!-- Official Designation -->
        <div class="form-group">
          <label>Your Official Designation <span style="color: red;">*</span></label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">badge</mat-icon>
            <select formControlName="officialDesignation">
              <option value="" disabled>Select designation</option>
              <option value="Principal">Principal</option>
              <option value="Teacher">Teacher</option>
              <option value="Coordinator">HM / Coordinator</option>
            </select>
          </div>
          <div *ngIf="enquirySubmitted && enquiryForm.controls['officialDesignation'].invalid" class="error-message">
            Designation is required
          </div>
        </div>

        <!-- Phone -->
        <div class="form-group">
          <label>Phone <span style="color: red;">*</span></label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">call</mat-icon>
            <input type="text" formControlName="phoneNumber" placeholder="e.g. 9876543210" />
          </div>
          <div *ngIf="enquirySubmitted && enquiryForm.controls['phoneNumber'].invalid" class="error-message">
            Enter a valid 10-digit phone number
          </div>
        </div>

        <!-- Email -->
        <div class="form-group">
          <label>Email <span style="color: red;">*</span></label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">email</mat-icon>
            <input type="email" formControlName="email" placeholder="example@gmail.com" />
          </div>
          <div *ngIf="enquirySubmitted && enquiryForm.controls['email'].invalid" class="error-message">
            Enter a valid email address
          </div>
        </div>

        <!-- City -->
        <div class="form-group">
          <label>City <span style="color: red;">*</span></label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">location_city</mat-icon>
            <input type="text" formControlName="city" placeholder="Example: Bangalore" />
          </div>
          <div *ngIf="enquirySubmitted && enquiryForm.controls['city'].invalid" class="error-message">
            City is required
          </div>
        </div>

        <!-- State (Optional) -->
        <div class="form-group">
          <label>State</label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">map</mat-icon>
            <input type="text" formControlName="state" placeholder="State (optional)" />
          </div>
        </div>

        <!-- Country (Optional) -->
        <div class="form-group">
          <label>Country</label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">public</mat-icon>
            <input type="text" formControlName="country" placeholder="Country (optional)" />
          </div>
        </div>

        <!-- Zipcode (Optional) -->
        <div class="form-group">
          <label>Zipcode</label>
          <div class="input-with-icon">
            <mat-icon class="input-icon">markunread_mailbox</mat-icon>
            <input type="text" formControlName="zipcode" placeholder="Zipcode (optional)" />
          </div>
        </div>

        <!-- Submit -->
        <div class="form-actions">
          <button type="submit" class="primary-btn" [disabled]="isLoading">
            {{ isLoading ? 'Submitting...' : 'Request Call Back' }}
          </button>
        </div>

      </form>
    </div>

  </div>
  <!-- Loader Overlay -->
  <div *ngIf="isLoading">
    <app-loader></app-loader>
  </div>
</div>